export class PaymentAction {
  request_token;
}
